module.exports = __webpack_public_path__ + "static/media/Wind.71c9d336.mp3";